var map = {
	"./galleryimage-1.jpg": 25345,
	"./galleryimage-10.jpg": 16125,
	"./galleryimage-12.jpg": 38351,
	"./galleryimage-2.jpg": 49558,
	"./galleryimage-3.jpg": 77971,
	"./galleryimage-4.jpg": 4160,
	"./galleryimage-5.jpg": 55901,
	"./galleryimage-6.jpg": 18098,
	"./galleryimage-7.jpg": 78127,
	"./galleryimage-8.jpg": 86668,
	"./galleryimage-9.jpg": 84457,
	"./gallerypop-1.jpg": 16039,
	"./gallerypop-10.jpg": 86151,
	"./gallerypop-12.jpg": 14485,
	"./gallerypop-2.jpg": 36056,
	"./gallerypop-3.jpg": 40373,
	"./gallerypop-4.jpg": 4750,
	"./gallerypop-5.jpg": 82795,
	"./gallerypop-6.jpg": 14492,
	"./gallerypop-7.jpg": 85017,
	"./gallerypop-8.jpg": 50530,
	"./gallerypop-9.jpg": 42239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42856;